// src/hooks/useEventListener.ts
import { useEffect, useRef } from "react";
var useEventListener = function useEventListener(eventName, handler, element, disabled) {
  var savedHandler = useRef();
  useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(function () {
    var _a;
    var isSupported = !disabled && ((_a = element == null ? void 0 : element.current) == null ? void 0 : _a.addEventListener);
    if (!isSupported) {
      return;
    }
    var node = element == null ? void 0 : element.current;
    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };
    node.addEventListener(eventName, eventListener);
    return function () {
      var _a2;
      (_a2 = node == null ? void 0 : node.removeEventListener) == null ? void 0 : _a2.call(node, eventName, eventListener);
    };
  }, [eventName, element == null ? void 0 : element.current, disabled]);
};
export { useEventListener };